import { useEffect, useRef, useState } from "react";
import { makePATCHRequest, makePOSTRequest } from "../../request/rawRequest";

import BasicPage from "../BasicPage/BasicPage";
import "../generalCSS/stylesheet.css";
import "../IonColor/color.css";
import { VideoList } from "./components/VideoList";
import "./Video.css";

interface ContainerProps {}

export type VideoGen = {
  _id: string;
  name: string;
  link: string;
  viewed: boolean;
  index: number;
  picture_url: string;
};

const setVideoViewed = async (id: any) => {
  await makePATCHRequest("/video/viewed?id_video=" + id);
};

const VideoGen: React.FC<ContainerProps> = () => {
  const params = new URLSearchParams(window.location.search);
  const theme: string = params.get("theme")!;
  const id: string = params.get("id")!;
  const [themeName, setThemeName] = useState<string>("");
  const [video, setVideo] = useState<VideoGen>({
    _id: "",
    name: "",
    link: "",
    viewed: false,
    index: 0,
    picture_url: "",
  });
  const [otherVideos, setOtherVideos] = useState<VideoGen[]>([]);
  const [sortedOV, setSortedOV] = useState<VideoGen[]>([]);
  const idMax = useRef(0);

  const fetchVideo = async (id?: string): Promise<VideoGen> => {
    const ret: VideoGen = {
      _id: "",
      name: "",
      link: "",
      viewed: false,
      index: 0,
      picture_url: "",
    };

    await makePOSTRequest("/videos", { _id: id ?? params.get("id") }).then(
      (data) => {
        ret._id = data[0]._id;
        ret.name = data[0].name;
        ret.link = data[0].link;
        ret.viewed = data[0].viewed;
        ret.index = data[0].index;
        ret.picture_url = data[0].picture_url || "";
      }
    );
    return ret;
  };

  const fetchTheme = async () => {
    await makePOSTRequest("/themes", { _id: params.get("theme") }).then(
      (response) => {
        setThemeName(response[0].name);
        for (let i = 0; i < response[0].id_videos.length; i++) {
          setOtherVideos([]);
          fetchVideo(response[0].id_videos[i]).then((resp) => {
            setOtherVideos((old) => [...old, resp]);
          });
        }
        idMax.current = response[0].id_videos.length - 1;
      }
    );
  };

  useEffect(() => {
    setSortedOV([...otherVideos].sort((a, b) => a.index - b.index));
  }, [otherVideos]);

  useEffect(() => {
    if (video._id === "") {
      fetchVideo().then((resp) => {
        setVideo(resp);
      });

      fetchTheme();
    }
  }, [video]);

  return (
    <BasicPage pathReturn title={themeName}>
      <VideoList
        videos={sortedOV.map((video) => ({
          _id: video._id,
          link: video.link,
          pictureUrl: video.picture_url,
          isViewed: video.viewed,
          name: video.name,
        }))}
        onVideoEnded={() => setVideoViewed(video._id)}
      />
    </BasicPage>
  );
};

export default VideoGen;
